import { render, staticRenderFns } from "./czkfirst.vue?vue&type=template&id=6c98684a&scoped=true"
import script from "./czkfirst.vue?vue&type=script&lang=js"
export * from "./czkfirst.vue?vue&type=script&lang=js"
import style0 from "./czkfirst.vue?vue&type=style&index=0&id=6c98684a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c98684a",
  null
  
)

export default component.exports